import { Button } from '../ui/button';
import { useTranslation } from 'react-i18next';
import { LogOut } from 'lucide-react';
import { useMsalLogout } from '@/auth/use-msal-logout';
import { FC } from 'react';

type Props = {
  variant: 'destructive' | 'outline';
};

export const LogoutButton: FC<Props> = ({ variant }) => {
  const { t } = useTranslation();
  const logout = useMsalLogout();

  return (
    <Button
      variant={variant}
      className="px-6 flex items-center space-x-2"
      onClick={logout}
      data-testid="logout-button"
    >
      <LogOut className="h-4 w-4" />
      <p>{t('settings_page.signOutLabel')}</p>
    </Button>
  );
};
